
/* eslint-disable global-require */
const Main = r => require.ensure([], () => r(require('./Main')), 'customers-bundle')
const Form = r => require.ensure([], () => r(require('./MainPanel')), 'customers-bundle')

export default [
  {
    name: 'customer.index',
    path: '/customers',
    component: Main,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'customer.new',
        path: 'create',
        component: Form,
        meta: { requiresAuth: true }
      },
      {
        name: 'customer.edit',
        path: ':id/edit',
        component: Form,
        meta: { requiresAuth: true }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/customers/routes.js